import User from "@higher/models/User";

import { stateSubscriptionById } from "./stateSubscriptionById";

const UsersCollection = "users";

export default stateSubscriptionById<User>("userById", UsersCollection);
